import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { ReportIcon } from "@common/reportIcon";
import { Props } from "./types";
import { GanttIcon } from "./ganttIcon";
import { ListIcon } from "./listIcon";
import { ProjectIcon } from "./projectIcon";
import { WorkloadsIcon } from "./workloadsIcon";
import { CalendarIcon } from "./calendarIcon";
import styles from "./styles.scss";

function Navigation(props: Props) {
  const { t } = useTranslation();

  return (
    <ul className={styles.navigation}>
      <li className={styles.item}>
        <NavLink
          to={`/zones/${props.zone.uuid}/projects`}
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <ProjectIcon className={styles.icon} />
          <p className={styles.text}>{t("zonePage.navigation.project")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to={`/zones/${props.zone.uuid}/lists`}
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <ListIcon className={styles.icon} />
          <p className={styles.text}>{t("zonePage.navigation.list")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to={`/zones/${props.zone.uuid}/gantt`}
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <GanttIcon className={styles.icon} />
          <p className={styles.text}>{t("zonePage.navigation.gantt")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to={`/zones/${props.zone.uuid}/calendar`}
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <CalendarIcon className={styles.icon} />
          <p className={styles.text}>{t("zonePage.navigation.calendar")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to={`/zones/${props.zone.uuid}/reports`}
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <ReportIcon className={styles.icon} />
          <p className={styles.text}>{t("zonePage.navigation.reports")}</p>
        </NavLink>
      </li>
      <li className={styles.item}>
        <NavLink
          to={`/zones/${props.zone.uuid}/workloads`}
          className={({ isActive }) =>
            classNames(styles.link, { [styles.selectedLink]: isActive })
          }
        >
          <WorkloadsIcon className={styles.icon} />
          <p className={styles.text}>{t("zonePage.navigation.workloads")}</p>
        </NavLink>
      </li>
    </ul>
  );
}

export { Navigation };
